import { TrendingUp } from "lucide-react";

export const DemandBadge = ({ signal, slug, size = 10, className = "" }) => {
  if (!signal) return null;
  return (
    <span
      className={`inline-flex max-w-full flex-wrap items-center justify-end gap-1 bg-amber-400/15 border border-amber-400/70 text-amber-200 text-[10px] tracking-[0.2em] uppercase px-2 py-1 leading-tight text-right font-bold ${className}`}
      data-testid={`demand-badge-${slug}`}
      title={`High demand · ${signal}`}
    >
      <TrendingUp size={size} strokeWidth={2.5} />
      High demand · {signal}
    </span>
  );
};

export const DemandEvidence = ({ evidence, slug, className = "" }) => {
  if (!evidence?.length) return null;
  return (
    <div className={`grid gap-px bg-amber-400/20 border border-amber-400/30 sm:grid-cols-3 ${className}`} data-testid={`demand-evidence-${slug}`}>
      {evidence.map((e) => (
        <div key={`${e.source}-${e.metric}`} className="bg-[#0b0908] px-5 py-4" data-testid={`demand-evidence-item-${slug}`}>
          <div className="font-display text-3xl font-black text-amber-200">{e.metric}</div>
          <div className="mt-1 text-sm text-zinc-300">{e.label}</div>
          <div className="mt-1 font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">Source · {e.source}</div>
        </div>
      ))}
    </div>
  );
};
